export default __webpack_public_path__ + "static/5_16-791a357456f182e9fc324707d6a3777c.png";